export default __webpack_public_path__ + "static/media/Jae 9781408360316.89914855.jpg";